module.exports = __webpack_public_path__ + "0.1.0/img/base.cf595fa8.png";